<template>
  <div>
    <!--Begin Tabelas de Aulas Agendadas-->
    <vuestic-widget v-if="tipoProcesso != 999">
      <div v-if="loadingAgendadas">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </div>
      <div v-else>
        <h3>Aulas Agendadas</h3>
        <div class="overflow-mobile">
          <table class="table table-striped large-table">
            <thead>
              <tr>
                <th>Instrutor</th>
                <th>Veículo</th>
                <th>Horário/Data</th>
                <th>Status</th>
                <th>Conteúdo</th>
              </tr>
            </thead>
            <tbody v-if="agendadas.length > 0">
              <tr v-for="aula in agendadas" :key="aula.id_aulas_praticas">
                <td>{{ aula.instrutor.nome }}</td>
                <td>{{ aula.veiculo.placa }}</td>
                <td>{{ utils.formatDate(aula.data_aula) }}</td>
                <td v-if="!aula.status">
									<!-- <span v-if="(new Date(aula.data_aula) > new Date() || (new Date(aula.data_aula)).setMinutes((new Date(aula.data_aula)).getMinutes() + 50) < new Date()) && aula.cancelada == false">
										Aula não realizada
									</span> -->
                  <span v-if="aula.id_anotacao_pratica == null && new Date() < new Date(new Date(aula.data_aula).getTime() + 50 * 60 * 1000)">
                    Aula não realizada
                  </span>
									<span v-else-if="new Date(aula.data_aula) < new Date() && aula.cancelada == false && !!aula.id_anotacao_pratica">
										Aula não enviada
									</span>
									<span v-else-if="(new Date(aula.data_aula)).setMinutes((new Date(aula.data_aula)).getMinutes() + 50) < new Date() && aula.cancelada == false && !aula.id_anotacao_pratica">
										Falta
									</span>
									<span v-else-if="aula.cancelada == true">Aula cancelada</span>
									<span v-else>-</span>
								</td>
								<td v-else>
									<span v-if="aula.cancelada == true">Aula cancelada</span>
									<span v-else>{{ aula.status }}</span>
								</td>
                <td>
                  {{ aula.conteudos.length > 0 ? aula.conteudos[0] : '-' }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">CANDIDATO NÃO POSSUI AULA AGENDADA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vuestic-widget>
    <!--End Tabelas de Aulas Agendadas-->

    <!--Begin Tabelas de Aulas Realizadas-->
    <vuestic-widget v-if="tipoProcesso != 999">
      <div v-if="loadingRealizadas">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </div>
      <div v-else>
        <h3>Aulas Realizadas</h3>
        <div class="overflow-mobile">
          <table class="table table-striped large-table">
            <thead>
              <tr>
                <th>Instrutor</th>
                <th>Veículo</th>
                <th>Horário/Data</th>
                <th>Status</th>
                <th>Conteúdo</th>
              </tr>
            </thead>
            <tbody v-if="realizadas.length > 0">
              <tr v-for="aula in realizadas" :key="aula.id_aulas_praticas">
                <td>{{ aula.instrutor.nome }}</td>
                <td>{{ aula.veiculo.placa }}</td>
                <td>{{ utils.formatDate(aula.data_aula) }}</td>
                <td>
                    <span v-if="aula.status">{{ aula.status }}</span>
                    <span v-else> Pendente {{ aula.status }}</span>
                  </td>
                <td>
                  {{ aula.conteudos.length > 0 ? aula.conteudos[0] : '-' }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">CANDIDATO NÃO POSSUI AULAS REALIZADAS</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vuestic-widget>
    <!--End Tabelas de Aulas Agendadas-->
  </div>
</template>

<script>

import urlApiV2 from '../../router/urlApiV2'
import * as spinners from 'epic-spinners'
import utils from '../../services/utils'

export default {
  name: 'aulasPraticas',
  components: {
    ...spinners,
  },
  data () {
    return {
      nome: window.localStorage['nome'] ? window.localStorage['nome'].toUpperCase() : '',
      autoescola: window.localStorage['nome_fantasia'] !== 'null' ? window.localStorage['nome_fantasia'].toUpperCase() : '',
      utils: utils,

      agendadas: [],
      realizadas: [],

      loadingAgendadas: false,
      loadingRealizadas: false,

      tipoProcesso: null,
    }
  },
  mounted () {
    this.tipoProcesso = localStorage.tipo_processo

    this.loadAgendadas()
    this.loadRealizadas()
  },
  methods: {
    async loadAgendadas () {
      this.loadingAgendadas = true

      const idAluno = JSON.parse(window.localStorage['aluno']).id_aluno

      await this.$http.get(urlApiV2 + `/alunos/praticas/${idAluno}/agendadas`)
        .then((response) => {
          this.agendadas = response.body.dados.agendadas
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loadingAgendadas = false
        })
    },
    async loadRealizadas () {
      this.loadingRealizadas = true

      const idAluno = JSON.parse(window.localStorage['aluno']).id_aluno

      await this.$http.get(urlApiV2 + `/alunos/praticas/${idAluno}/realizadas`)
        .then((response) => {
          this.realizadas = response.body.dados.realizadas
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loadingRealizadas = false
        })
    },
  },
}
</script>

<style>
@media(max-width: 767px) {

  .table td,
  .table th,
  .table thead th,
  .table thead td {
    font-size: 12px !important;
  }

  .overflow-mobile {
    overflow-x: auto;
  }

  .large-table {
    width: auto;
  }
}

.btnpresenca {
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 3px;
  width: 135px !important;
  margin: 0 auto !important;
  height: 35px;
  padding-left: 15px;
}

.table td,
.table th,
.table thead th,
.table thead td {
  text-align: center !important;
}

.vuestic-modal .my-modal-body {
  background-color: #ffedc1;
  font-size: 20px;
  padding: 40px;
  border-radius: 0px !important;
  margin: 0px !important;
  width: auto !important;
  height: auto !important;
}

.btnpresenca:hover {
  color: #ffffff;
  border-radius: 3px;
}

.btnpresenca:focus {
  outline: none;
  box-shadow: none;
  color: #ffffff;
  border-radius: 3px;
}

.fa.fa-sign-in {
  width: 150px;
}

.btnmodal {
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 3px;
  width: auto !important;
  padding: 0px 20px !important;
  height: 35px;
  margin: 5px;
}

.btnmodal:hover {
  color: #ffffff;
  border-radius: 3px;
}

.btnmodal:focus {
  outline: none;
  box-shadow: none;
  color: #ffffff;
  border-radius: 3px;
}
</style>
